import Component from "./ProviderClinicsProgramEnrollmentPage";

export default Component;
